import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { ProductBody, ProductDetails, ProductListItem } from "types/api/product";

function useProductApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllProduct = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<ProductListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<ProductListItem>>({
            url: "/product",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneProduct = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ProductDetails> => {
        return get<PathParamsWithId, undefined, ProductDetails>({
            url: "/product/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createProduct = React.useCallback((body: ProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ProductBody, ResponseWithId>({
            url: "/product",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateProduct = React.useCallback((pathParams: PathParamsWithId, body: ProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ProductBody, null>({
            url: "/product/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteProduct = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    const duplicateProduct = React.useCallback((pathParams: PathParamsWithId, body: null, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<PathParamsWithId, undefined, null, ResponseWithId>({
            url: "/product/duplicate/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    return {
        getAllProduct,
        getOneProduct,
        createProduct,
        updateProduct,
        deleteProduct,
        duplicateProduct
    };
}

export default useProductApi;